import React from 'react';

import './styles.css';

const PodBanner = ({ children, footer }) => {
  return children ? (
    <div data-cy="pod-banner" className="pod-banner-container">
      <div className="pod-banner">{children}</div>
      <div className="hub-data-pod-anti-row" />
      {footer && <div className="pod-banner-footer">{footer}</div>}
    </div>
  ) : null;
};

export default PodBanner;
